import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Dynamically import all JSON files from the locales directory
const resources = {};
const requireContext = require.context("./locales", true, /\.json$/);
requireContext.keys().forEach((fileName) => {
  const lang = fileName.replace("./", "").replace(".json", ""); // Extract the language code
  resources[lang] = {
    translation: requireContext(fileName), // Import the JSON file
  };
});

i18n
  .use(LanguageDetector) // Add the language detector
  .use(initReactI18next) // Pass the i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: "en", // Fallback language
    interpolation: {
      escapeValue: false, // React already protects from XSS
    },
    detection: {
      // LanguageDetector settings
      order: ["localStorage", "navigator"], // Check localStorage first, then browser settings
      caches: ["localStorage"], // Store the selected language in localStorage
    },
  });

export default i18n;
